"use client";

import { ArrowUpRight, Bike, Bus, CarFront, TrainFront } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurServiceArea() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const transports = [{
    icon: TrainFront,
    label: "Emergency Response · 24/7",
    detail: "Rapid deployment for critical electrical failures"
  }, {
    icon: Bus,
    label: "Residential · Full Service",
    detail: "Wiring, lighting, and panel upgrades for homes"
  }, {
    icon: Bike,
    label: "Commercial · Infrastructure",
    detail: "Certified solutions for business power systems"
  }, {
    icon: CarFront,
    label: "Safety Inspections · Certified",
    detail: "Comprehensive code compliance and safety audits"
  }];
  return <section data-section-id="550" id="our-service-area" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-10 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="lg:col-span-3 relative">
            <div className="relative overflow-hidden rounded-lg shadow-lg h-[420px] sm:h-[520px] lg:h-full min-h-[500px] bg-secondary">
              <iframe title="Current Pulse Electric Service Map" src="https://www.openstreetmap.org/export/embed.html?bbox=-73.99%2C40.69%2C-73.98%2C40.70&layer=mapnik&marker=40.6925%2C-73.9875" className="absolute inset-0 w-full h-full grayscale-[40%] contrast-110" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />

              {}
              <div className="pointer-events-none absolute inset-0" style={{
              background: "linear-gradient(135deg, hsla(54, 100%, 50%, 0.15) 0%, hsla(215, 60%, 12%, 0.25) 100%)"
            }} aria-hidden="true" />

              {}
              <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <div className="relative flex items-center justify-center">
                  <span className="absolute inline-flex h-16 w-16 rounded-lg bg-primary opacity-40 animate-ping" />
                  <span className="absolute inline-flex h-10 w-10 rounded-lg bg-primary opacity-60 animate-pulse" />
                  <span className="relative inline-flex h-6 w-6 rounded-lg bg-primary ring-4 ring-background shadow-lg" />
                </div>
                <div className="mt-3 flex justify-center">
                  <span className="inline-flex items-center gap-1.5 rounded-lg bg-foreground text-primary px-3 py-1.5 text-xs font-semibold shadow-lg font-default tracking-wide">
                    <span className="inline-block h-1.5 w-1.5 rounded-lg bg-primary" />
                    CURRENT PULSE
                  </span>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-2 bg-card rounded-lg p-7 sm:p-10 lg:p-12 flex flex-col border border-border">
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-muted-foreground font-default">
              Our Coverage
            </span>
            <h2 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-foreground font-default leading-[1.05]">
              Powering
              <br />
              your <span className="text-primary">future.</span>
            </h2>

            <p className="mt-5 text-base text-muted-foreground max-w-md">
              Serving the greater metropolitan area with precision electrical engineering and rapid-response repair services.
            </p>

            <div className="mt-8 flex-1 flex flex-col">
              {transports.map((t, i) => {
              const Icon = t.icon;
              return <div key={i} data-index={i}>
                    {i > 0 && <Separator className="bg-border/70" />}
                    <div className="flex items-start gap-5 py-5">
                      <div className="flex-shrink-0 flex h-12 w-12 items-center justify-center rounded-lg bg-secondary text-primary">
                        <Icon className="h-5 w-5" strokeWidth={1.5} />
                      </div>
                      <div className="flex-1 min-w-0 pt-1">
                        <p className="text-base font-semibold text-foreground font-default">
                          {t.label}
                        </p>
                        <p className="mt-1 text-sm text-muted-foreground">
                          {t.detail}
                        </p>
                      </div>
                    </div>
                  </div>;
            })}
            </div>

            {}
            <div className="mt-6 rounded-lg border border-border bg-background/50 p-5">
              <p className="text-sm text-foreground">
                <span className="font-semibold font-default">Need help? </span>
                Emergency dispatch available 24/7 for urgent electrical issues.
              </p>
              <Button variant="link" className="mt-1 h-auto p-0 text-primary-foreground bg-transparent hover:bg-transparent" asChild>
                <a href="/LetsTalkPage" className="inline-flex items-center gap-1 text-sm font-semibold text-foreground font-default group cursor-pointer">
                  Request Service Now
                  <span className="inline-flex h-5 w-5 items-center justify-center rounded-lg bg-primary text-primary-foreground transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5">
                    <ArrowUpRight className="h-3 w-3" strokeWidth={2.5} />
                  </span>
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}